import { Component, OnInit, Input, ViewEncapsulation, OnDestroy, AfterViewInit, ViewChild, Injectable, Inject } from '@angular/core';

import { ROWS_PER_PAGE_OPTIONS, AuthService, CacheService, CommonService } from '../../../common/service';
import { SensorFailureAudit } from '../../../common/model';
import { Permission } from '../../../common/enum';
import { Table, TableModule } from 'primeng/table';
import { NgIf, NgFor, NgSwitch, NgSwitchCase, NgClass, NgSwitchDefault, DecimalPipe, DatePipe } from '@angular/common';
import { PrimeTemplate } from 'primeng/api';
import { ButtonDirective } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';

import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'sensor-failures-audit-grid',
    templateUrl: './sensor-failures-audit-grid.component.html',
    encapsulation: ViewEncapsulation.None,
    imports: [NgIf, TableModule, PrimeTemplate, ButtonDirective, TooltipModule, FormsModule, NgFor, NgSwitch, NgSwitchCase, NgClass, InputTextModule, NgSwitchDefault, CheckboxModule, DecimalPipe, DatePipe]
})
export class SensorFailuresAuditGridComponent implements OnInit, AfterViewInit {
  @ViewChild('dt') private dt: Table;
  @Input() sensorFailureAudit: SensorFailureAudit[];
  @Input() visible: boolean;
  Permission = Permission;
  cols: any;
  selectedCols: any;
  defaultCols: any = [];
  _rows: SensorFailureAudit[];
  rowsPerPage: number;
  rowsPerPageOptions = [...ROWS_PER_PAGE_OPTIONS];
  rows: SensorFailureAudit[];

  constructor( @Inject(AuthService) public authService: AuthService,
    @Inject(CacheService) public cacheService: CacheService,
    @Inject(CommonService) public commonService: CommonService) { }

  ngOnInit() {
    this.rowsPerPage = this.cacheService.GetLocal(`SensorFailuresAuditGrid-RowsPerPage`, 10);
    this.cols = this.getColConfig();
    this.selectedCols = this.cacheService.GetLocal(`SensorFailuresAuditGrid-SelectedCols`, this.cols.filter(c => c.isHidden === false));
    this.cacheService.SetLocal('login-lastChoice', 'workflow/fails');
  }

  ngAfterViewInit() {
    if (!this.commonService.isNullOrUndefined(this.dt)) {
      if (localStorage.getItem(this.dt.stateKey)) {
        const table = JSON.parse(localStorage.getItem(this.dt.stateKey));
        table.filters = {};
        delete table.columnWidths;
        localStorage.setItem(this.dt.stateKey, JSON.stringify(table));
        this.dt.restoreState();
      }
    }
  }


  show() {
    this._rows = JSON.parse(JSON.stringify(this.sensorFailureAudit));
    this.loadPodData();
  }

  getColConfig() {
    return [
      { field: 'status_description', header: 'Status', isHidden: false, isReadonly: true, datatype: 'string', colWidth: '60px' },
      { field: 'created_date', header: 'Date', isHidden: false, isReadonly: true, datatype: 'Date', colWidth: '30px' },
      { field: 'amended_by', header: 'User / Process', isHidden: false, isReadonly: true, datatype: 'string', colWidth: '40px' },
      { field: 'notes', header: 'Notes', isHidden: false, isReadonly: true, datatype: 'string', colWidth: '200px' }
    ];
  }

  loadPodData() {
    if (this.sensorFailureAudit != null) {
      this.rowsPerPageOptions = [...ROWS_PER_PAGE_OPTIONS];
      this.rows = [...this.sensorFailureAudit];
    }
  }

  setPreferences() {
    this.cacheService.SetLocal(`SensorFailuresAuditGrid-RowsPerPage`, this.rowsPerPage);
    this.cacheService.SetLocal(`SensorFailuresAuditGrid-SelectedCols`, this.selectedCols);
    if (!this.commonService.isNullOrUndefined(this.dt)) {
      if (localStorage.getItem(this.dt.stateKey)) {
        const table = JSON.parse(localStorage.getItem(this.dt.stateKey));
        table.columnWidths = '';
        delete table.columnWidths;
        localStorage.setItem(this.dt.stateKey, JSON.stringify(table));
        this.dt.restoreState();
        this.dt.reset();
      }
    }
    this.defaultCols = this.getColConfig();
    this.selectedCols.forEach(item1 => {
      var itemFromArr2 = this.defaultCols.find(item2 => item2.field === item1.field);

      if (itemFromArr2) {
        item1.width = itemFromArr2.width;
      }
    });

  }

  has(requiredPermissions: Permission | Permission[]) {
    return this.authService.hasPermission(requiredPermissions);
  }
}
